import { CustomerEntity } from "../../features/invoices/domain/entities/CustomerEntity";
import { Currency } from "../data/api/currenciesApi";
import { GSTINVerificationResult } from "../data/api/gstinVerificationApi";
import { findCountryByCode } from "../constants/countries";
import { getCurrencyIdForCountry } from "./countryCurrency";
import { extractPanFromGstin } from "./gstinUtils";
import { GstinPrefillField } from "./vendorGstinPrefill";

export function buildCustomerGstinPrefillFields(
  formData: Partial<CustomerEntity>,
  verificationData: GSTINVerificationResult | null,
  gstin: string,
  currencies: Currency[],
): GstinPrefillField[] {
  const pan = extractPanFromGstin(gstin);
  const inrCurrency = currencies.find((c) => c.currency_code === "INR");
  const currentCurrencyName = formData.currency_id
    ? currencies.find((c) => c.currency_id === formData.currency_id)
        ?.currency_name || ""
    : "";

  return [
    {
      label: "Customer Name",
      currentValue: (formData.customer_name as string) || "",
      newValue: verificationData?.legal_name || "",
    },
    {
      label: "Billing Address",
      currentValue: (formData.billing_address as string) || "",
      newValue: verificationData?.address || "",
    },
    {
      label: "State",
      currentValue: (formData.state as string) || "",
      newValue: verificationData?.state || "",
    },
    {
      label: "City",
      currentValue: (formData.city as string) || "",
      newValue: verificationData?.city || "",
    },
    {
      label: "Postal Code",
      currentValue: (formData.postal_code as string) || "",
      newValue: verificationData?.pincode || "",
    },
    {
      label: "Country",
      currentValue: formData.country
        ? findCountryByCode(formData.country)?.name || formData.country
        : "",
      newValue: findCountryByCode("IN")?.name || "India",
    },
    {
      label: "PAN Tax ID",
      currentValue: (formData.pan_tax_registration_no as string) || "",
      newValue: pan || "",
    },
    {
      label: "Currency",
      currentValue: currentCurrencyName,
      newValue: inrCurrency?.currency_name || "INR",
    },
  ];
}

export function buildCustomerGstinPrefillUpdates(
  verificationData: GSTINVerificationResult | null,
  gstin: string,
  currencies: Currency[],
): Partial<CustomerEntity> {
  const pan = extractPanFromGstin(gstin);
  const currencyId = getCurrencyIdForCountry("IN", currencies);

  const updates: Partial<CustomerEntity> = { country: "IN" };

  if (verificationData?.legal_name) {
    updates.customer_name = verificationData.legal_name;
  }
  if (verificationData?.address) {
    updates.billing_address = verificationData.address;
  }
  if (verificationData?.state) {
    updates.state = verificationData.state;
  }
  if (verificationData?.city) {
    updates.city = verificationData.city;
  }
  if (verificationData?.pincode) {
    updates.postal_code = verificationData.pincode;
  }
  if (pan) {
    updates.pan_tax_registration_no = pan;
  }
  if (currencyId) {
    updates.currency_id = currencyId;
  }

  return updates;
}
